import { useStaticQuery, graphql } from 'gatsby';

export interface UseGenderResponseItem {
  id: string;
  name: string;
}
export type UseGenderResponse = UseGenderResponseItem[];
export function useGender(): UseGenderResponse {
  const { allPawsGender } = useStaticQuery(graphql`
    query {
      allPawsGender {
        nodes {
          id: remoteId
          name
        }
      }
    }
  `);

  return allPawsGender.nodes;
}
